import { observable, makeObservable, override } from 'mobx';

import { ICategoryInfo } from '@gem/models/commonModel';
import { IBotCommand, IBotUserDisplayData } from '@gem/models/userModel';

import { UsersStore } from 'STORE/Users/Users';

import { User } from '../User';

export class Bot extends User {
  @observable categoryId: string | null;
  @observable categoryInfo: ICategoryInfo;
  @observable description: string;
  @observable addedToProfile: boolean;
  @observable groupId: string | null;
  @observable commands: IBotCommand[];
  @override verified: boolean;

  constructor(users: UsersStore, data: IBotUserDisplayData) {
    super(users, data);

    makeObservable(this);

    this.categoryId = data.categoryId || null;
    this.categoryInfo = data.categoryInfo;
    this.description = data.description;
    this.addedToProfile = data.addedToProfile;
    this.verified = data.verified;
    this.groupId = data.groupId || null;
    this.commands = data.commands;
  }

  get isBot(): boolean {
    return true;
  }

  @override
  get displayName(): string {
    return this.userName;
  }

  @override
  get avatarTitle(): string {
    return this.displayName;
  }

  @override
  update(data: IBotUserDisplayData): void {
    super.update(data);

    this.categoryId = data.categoryId || null;
    this.categoryInfo = data.categoryInfo;
    this.description = data.description;
    this.addedToProfile = data.addedToProfile;
    this.verified = data.verified;
    this.groupId = data.groupId || null;
    this.commands = data.commands;
  }
}
